import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";
import {
  notesListThunk,
  createNoteThunk,
  updateNoteThunk,
  deleteNoteThunk,
} from "thunks/note";

const initialState = {
  recordingIds: [],
  hash: {},
  loading: { create: false, update: false, delete: false },
  error: { create: null, update: null, delete: null },
};

const noteSlice = createSlice({
  name: "note",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #region pending
      .addCase(notesListThunk.pending, (state, action) => {
        const folderId = action.payload;
        state.loading[folderId] = true;
      })
      .addCase(createNoteThunk.pending, (state) => {
        state.loading.create = true;
      })
      .addCase(updateNoteThunk.pending, (state) => {
        state.loading.update = true;
      })
      .addCase(deleteNoteThunk.pending, (state) => {
        state.loading.delete = true;
      })
      // #endregion
      // #region fulfilled
      // #endregion
      // #region rejected
      .addCase(notesListThunk.rejected, (state, action) => {
        const {
          error,
          payload: { folderId },
        } = action;
        state.loading[folderId] = true;
        state.error[folderId] = error;
      })
      .addCase(createNoteThunk.rejected, (state, action) => {
        const { error } = action;
        state.loading.create = false;
        state.error.create = error;
      })
      .addCase(updateNoteThunk.rejected, (state, action) => {
        const { error } = action;
        state.loading.update = false;
        state.error.update = error;
      })
      .addCase(deleteNoteThunk.rejected, (state, action) => {
        const { error } = action;
        state.loading.delete = false;
        state.error.delete = error;
      })
      // #endregion
      .addCase(clearStore, () => initialState);
  },
});

export const actions = noteSlice.actions;

export default noteSlice.reducer;
